var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "markbox",
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loadEffect" }, [
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span"),
      _c("span"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }